import React, {useEffect} from 'react';
import {Container} from "react-bootstrap";
import {useLocation, useNavigate} from "react-router-dom";
import OrderInfo from "../components/Order/OrderInfo";
import OrderSuccess from "../components/Order/OrderSuccess";
import {observer} from "mobx-react-lite";

const Order = observer(() => {
    const location = useLocation();
    const basket = JSON.parse(location.state?.basket || null)
    const mart = JSON.parse(location.state?.mart || null)
    const address = JSON.parse(location.state?.address || null)
    const navigate = useNavigate();
    const [orderStatus, setOrderStatus] = React.useState(false)

    useEffect(() => {
        if (basket == null || mart == null || address == null) {
            navigate('/')
        }
    }, []);

    return (
        <Container>
            {(basket != null || mart != null || address != null) && (orderStatus === false) &&
                <OrderInfo basket={basket} mart={mart} address={address} setOrderStatus={setOrderStatus}/>
            }
            {orderStatus === true &&
                <OrderSuccess />
            }
        </Container>
    );
});

export default Order;